import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import IconCard from '../IconCard';

const OverlapMenuInnerWrapper = ({
  data,
  cardWidth,
  cardHeight,
  cardSidePadding,
  cardImageSize,
  colors,
  onItemClick,
  onBackdropClick,
  cardBoxShadow
}) => {
  const { t } = useTranslation();
  const selectedData = data.length > 9 ? data.slice(0, 9) : data;
  return (
    <Root onClick={e => e.currentTarget === e.target && onBackdropClick()}>
      {selectedData.map(menuItem => {
        const iconWidth = menuItem.iconWidth ? menuItem.iconWidth : cardImageSize.width;
        const iconHeight = menuItem.iconHeight ? menuItem.iconHeight : cardImageSize.height;

        return (
          <Wrapper key={menuItem.label} boxSideMargin={cardSidePadding}>
            <Card
              width={cardWidth}
              height={cardHeight}
              itemSidePadding={cardSidePadding}
              iconWidth={iconWidth}
              iconHeight={iconHeight}
              icon={menuItem.icon}
              iconHover={menuItem.iconHover}
              title={t(menuItem.label)}
              backgroundColor={colors.mainBackground}
              textColor={colors.mainColor}
              hoverBackgroundColor={colors.hoverBackground}
              hoverTextColor={colors.hoverColor}
              onClick={() => onItemClick(menuItem)}
              cardBoxShadow={cardBoxShadow}
            />
          </Wrapper>
        );
      })}
    </Root>
  );
};

OverlapMenuInnerWrapper.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
      iconHover: PropTypes.string,
      children: PropTypes.arrayOf(PropTypes.shape({}))
    })
  ).isRequired,
  cardWidth: PropTypes.number,
  cardHeight: PropTypes.number,
  cardSidePadding: PropTypes.number,
  cardImageSize: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number
  }),
  colors: PropTypes.shape({
    mainColor: PropTypes.string,
    mainBackground: PropTypes.string,
    hoverColor: PropTypes.string,
    hoverBackground: PropTypes.string
  }),
  onItemClick: PropTypes.func.isRequired,
  onBackdropClick: PropTypes.func,
  cardBoxShadow: PropTypes.string
};

OverlapMenuInnerWrapper.defaultProps = {
  cardSidePadding: 20,
  onBackdropClick: () => {},
  cardBoxShadow: ''
};

const Root = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  margin: ${props => (props.boxSideMargin ? -props.boxSideMargin : -10)}px;
`;

const Wrapper = styled.div`
  padding: ${props => (props.boxSideMargin ? props.boxSideMargin / 2 : 10)}px;
`;

const Card = styled(IconCard)`
  color: ${props => props.textColor};
  background-color: ${props => props.backgroundColor};
  box-shadow: ${props => props.cardBoxShadow};
  &:hover {
    color: ${props => props.hoverTextColor};
    background-color: ${props => props.hoverBackgroundColor};
  }
`;

export default OverlapMenuInnerWrapper;
